<template>
  <v-autocomplete
      :filled="!!filled"
      v-model="currentValue"
      :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-translate' : ''"
      :items="$locale.languagesItems"
      hide-no-data
      :label="$t('label')"
      hide-details
      @keyup.enter.prevent="$emit('enter')"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'LanguageSelect',
  props: ['value', 'filled'],
  data () {
    return {
      currentValue: this.value,
    }
  },
  watch: {
    currentValue () {
      this.$emit('update:value', this.currentValue)
    },
    value (value) {
      this.currentValue = value
    }
  },
}
</script>

<i18n>
{
	"en": {
		"label": "Language"
	},
	"es": {
		"label": "Lengua"
	},
	"fr": {
		"label": "Langue"
	},
	"it": {
		"label": "Lingua"
	},
	"pt": {
		"label": "Idioma"
	},
	"pl": {
		"label": "Język"
	}
}
</i18n>